export enum PublishMessages {
  accountDataLoaded = 'account_data_loaded',
  cardAndInvoiceDataLoaded = 'card_and_invoice_data_loaded',
  usageStatsLoaded = 'usage_stats_data_loaded',
  showReactivate = 'show_reactivate_dialog',
  cancelSubscription = 'cancel_subscription',
  reactivateSubscription = 'reactivate_subscription',
  paymentMethodChanged = 'payment_method_changed',
}
